import angular from 'angular';
import serviceModule from '../services/service.module';

import AlertsFilter from './alerts.filter';
import CapitalizeFilter from './attrs.capitalize.filter';
import AttrsTranslateFilter from './attrs.translate.filter';
import AttrsValueTranslateFilter from './attrs.translate.value.filter';
import TableDateFilter from './tableDate.filter';
import DateFilter from './date.filter';
import PropsFilter from './propsfilter.filter';
import SearchByNameFilter from './searchByName.filter';
import ReverseFilter from './reverse.filter';
import StartFromFilter from './startFrom.filter';
import CapitalizeFirstLetterFilter from './capitalizeFirstLetter.filter';
import twoDecimal from './twoDecimal.filter';
import toArray from './toArray.filter';
import FriendlyAttributesFilter from './attrs-friendly.filter';
import RemoveWhiteSpace from './removeWhiteSpace.filter';

const filterModule = angular.module('app.filters', ['gettext', serviceModule]);

filterModule
  .filter('alerts', AlertsFilter)
  .filter('capitalize', CapitalizeFilter)
  .filter('attrsTranslate', AttrsTranslateFilter)
  .filter('attrsValueTranslate', AttrsValueTranslateFilter)
  .filter('capitalizeFirstLetter', CapitalizeFirstLetterFilter)
  .filter('DateFilter', DateFilter)
  .filter('propsFilter', PropsFilter)
  .filter('reverse', ReverseFilter)
  .filter('searchByName', SearchByNameFilter)
  .filter('startFrom', StartFromFilter)
  .filter('TableDateFilter', TableDateFilter)
  .filter('twoDecimal', twoDecimal)
  .filter('toArray', toArray)
  .filter('toFriendlyAttr', FriendlyAttributesFilter)
  .filter('removeWhiteSpace', RemoveWhiteSpace);

export default filterModule.name;
